import apiClient from './apiClient';

// Every engine module (Threat Intel, Email Security, Threat Detection, AI
// Intelligence, Malware Analysis, Network Discovery, Pentest, Endpoint
// Analysis, Vulnerability Assessment, Automation Engine) exposes the exact
// same three endpoints under its own basePath — GET .../module/state,
// {method} .../module/status, {method} .../module/config (see any service's
// app/api/v1/module.py). One shared client for all of them, rather than
// hand-rolling the same three calls ten times.
//
// One service (automation-engine-service) uses PATCH for status/config
// where every other service uses PUT — verified per-service rather than
// assumed, since the two prior status/config calls silently 405 against a
// PATCH-only route. Defaults to PUT; pass method: 'patch' for that one.
export function createModuleControlApi(basePath, { method = 'put' } = {}) {
  return {
    fetchState: async () => {
      const { data } = await apiClient.get(`${basePath}/module/state`);
      return data;
    },
    updateStatus: async (status) => {
      const { data } = await apiClient[method](`${basePath}/module/status`, { status });
      return data;
    },
    updateConfig: async ({ sensitivity, schedule }) => {
      const { data } = await apiClient[method](`${basePath}/module/config`, { sensitivity, schedule });
      return data;
    },
  };
}
